import axios from 'axios';
import { handleError, handleResponse } from '../utils/ServideHelper';

const Method = {
    GET: 'get',
    POST: 'post',
};

const url = {
    recursosCritidos: '/capacityrule/recurso-critico',
    fabricaNo: '/capacityrule/fabrica-no',
    capacidades: '/capacityrule/plano-mestre',
    necessidades: '/capacityrule/necessidades',
    capacidadeRecursoCritico: '/dadomestre/capacidade-recurso-critico/listar',
};

export const getRecursosCriticos = (dadosResumido, date) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: url.recursosCritidos,
            method: Method.GET,
            params: { dadosResumido, date },
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};

export const getRecursosCriticoNew = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: url.capacidadeRecursoCritico,
            method: Method.GET,
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};

export const getFabricaNo = (dadosResumido) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: url.fabricaNo,
            method: Method.GET,
            params: { dadosResumido },
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};

export const getCapacidades = (tableVersionName) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: url.capacidades,
            method: Method.GET,
            params: { tableVersionName },
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};

export const getNecessidades = (params) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: url.necessidades,
            method: Method.GET,
            params,
        };

        axios(config).then(handleResponse(resolve)).catch(handleError(reject));
    });
};
